<template lang="pug">
    layout(:page="'registration'")
        template(slot="title")

            div

                // Title
                title-component(:title="$t('auth.registration.title')" type="h1")

                // Message
                div(v-html="$t('auth.registration.message')")

        // Registration form
        registration-form
</template>

<script>
    import RegistrationForm from './RegistrationForm';
    import Layout from '../Layout';
    import Title from '~components/Title';

    export default {
        components: {
            RegistrationForm: RegistrationForm,
            Layout,
            TitleComponent: Title
        }
    };
</script>
